import Api from "../../../util/Api";

export default function getInitState() {
    return {
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },

        ],
        tableAdditionalConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "companySiteName",
                label:"Ellátóhely",
                visibility: true
            },
            {
                name: "appointment",
                label: "Időpont",
                visibility: true,
                slot_name: 'created_on_format',
            },
            {
                name: "doctorName",
                label: "Orvos",
                sort: true,
                visibility: true
            },
            {
                name: "treatmentTypeTitle",
                label: "Vizsgálat",
                sort: true,
                visibility: true
            },
            {
                name: "patientName",
                label: "Páciens neve",
                sort: true,
                visibility: true
            },
            {
                name: "treatmentTypePrice",
                label: "Ár (HUF)",
                sort: true,
                visibility: true
            },
            {
                name: "patientDateOfBirth",
                label: "Páciens születési dátuma",
                sort: true,
                visibility: true
            },
            {
                name: "patientAddress",
                label: "Páciens címe",
                sort: true,
                visibility: true
            },
            {
                name: "appointmentType",
                label: "Típus",
                sort: true,
                visibility: true
            },
            {
                name: "cancelledDate",
                label: "Lemondás ideje",
                sort: true,
                visibility: true,
                slot_name: 'datetime_format',
            },
            {
                name: "cancelledBy",
                label: "Lemondás rögzítője",
                sort: true,
                visibility: true,
            },
            {
                name: "intervalInHours",
                label: "Intervallum (óra)",
                sort: true,
                visibility: true,
                slot_name: 'interval_format',
            },
            {
                name: "partner",
                label: "Partner",
                sort: true,
                visibility: true
            },
            {
                name: "appointmentCreatedBy",
                label: "Időpont rögzítője",
                sort: true,
                visibility: true,
            },
            {
                name: "appointmentNote",
                label: "Megjegyzés",
                visibility: true,
            },
            {
                name: "appointmentStatus",
                label: "Státusz",
                sort: true,
                visibility: true,
            },
            
        ],
        searchFields: [
            {
                name: "companySiteName",
                label:"Ellátóhely",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "appointmentFrom",
                label: "Időponttól",
                formSize: 3,
                formType: 'date',
                formVisible: true,
            },
            {
                name: "appointmentTo",
                label: "Időpontig",
                formSize: 3,
                formType: 'date',
                formVisible: true,
            },
            {
                name: "doctorName",
                label: "Orvos",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "treatmentTypeTitle",
                label: "Vizsgálat",
                formSize:3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTreatmentType,
                    formatText: function (val) {
                        return val.title;
                    },
                    formatOption: function (val) {
                        return val.title;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'title',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "examinationPrice",
                label: "Ár",
                formSize:3,
                formVisible: true
            },
            {
                name: "patientName",
                label: "Páciens neve",
                formSize: 3,
                formVisible: true
            },   
            {
                name: "patientDateOfBirth",
                label: "Páciens születési dátuma",
                formType: 'date',
                formSize:3,
                formVisible: true
            },
            {
                name: "patientAddress",
                label: "Páciens címe",
                formSize:3,
                formVisible: true
            },
            {
                name: "appointmentType",
                label: "Típus",
                formSize:3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 0, text: 'Lemondott'},
                        {id: 1, text: 'No show'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "cancelledDateFrom",
                label: "Lemondás idejétől",
                formSize: 3,
                formType: 'date',
                formVisible: true,
            },
            {
                name: "cancelledDateTo",
                label: "Lemondás idejéig",
                formSize: 3,
                formType: 'date',
                formVisible: true
            },
            {
                name: "cancelledBy",
                label: "Lemondás rögzítője",
                formSize:3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllCreatedBy,
                    formatText: function (val) {
                        return val.fullname;
                    },
                    formatOption: function (val) {
                        return val.fullname;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'fullname',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "intervalFrom",
                label: "Intervallumtól (óra)",
                formSize:3,
                formVisible: true
            },
            {
                name: "intervalTo",
                label: "Intervallumig (óra)",
                formSize:3,
                formVisible: true
            },
            {
                name: "partner",
                label: "Partner",
                formSize:3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getPartnersToSelect,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "appointmentStatus",
                label: "Státusz",
                formSize:3,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAppointmentStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "appointmentCreatedBy",
                label: "Időpont rögzítője",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllCreatedBy,
                    formatText: function (val) {
                        return val.fullname;
                    },
                    formatOption: function (val) {
                        return val.fullname;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'fullname',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formVisible: true
            },
            {
                name: "appointmentNote",
                label: "Megjegyzés",
                formSize:5,
                formVisible: true,
            },
        ],
    }
}